<template>
  <div v-if="isShowBlock" :class="$style.faqBlock">
    <h2 :class="$style.faqBlockTitle">
      {{ data.title }}
    </h2>
    <BitAccordionItem
      v-for="faq of filteredFaqElements"
      :key="faq.id"
      :class="$style.faqBlockItem"
      :title="faq.questionText"
    >
      <Markdown
        :is-link-new-page-open="faq.linksNewPage"
        :auto-link-parse="faq.autoLinkFormat"
        :text="faq.answerText"
      />
    </BitAccordionItem>
  </div>
</template>

<script lang="ts" setup>
import { BitAccordionItem } from '@bit/ui-kit';
import Markdown from '~/components/markdown.vue';
import { useStoreCountry } from '~/stores/client/country';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import type { ComponentInfoPageBlocksFaqBlock } from '~/types/infoPages';

const props = defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksFaqBlock>,
    required: true,
  },
});

const storeSsPlayer = useStoreSsPlayer();
const storeCountry = useStoreCountry();

const isShowBlock = computed(() => {
  if (props.data && !storeSsPlayer.isPlayerDataLoadingFirstInitOnce) {
    return true;
  }
  if (props.data && props.data.showForGuests === false) {
    return storeSsPlayer.isPlayerAuthorised;
  } else if (props.data) {
    return true;
  }
  return false;
});

const filteredFaqElements = computed(() => {
  const isPlayerFromAustralia = storeCountry.country === 'AU';

  return props.data.faqElements.filter((faq) => {
    if (faq.hideForAustralia && isPlayerFromAustralia) {
      return false;
    }
    return true;
  });
});
</script>

<style lang="scss" module src="./faqBlock.scss"></style>
